import { ConversationHistoryState } from "./conversation-history-atom-reducer";
import {
    UseConversationActionsResult,
    useConversationHistoryActions,
} from "./use-conversation-history-actions.hook";
import { useConversationHistoryState } from "./use-conversation-history-state.hook";

export interface UseConversationHistoryHookResult
    extends ConversationHistoryState,
        UseConversationActionsResult {}

export function useConversationHistory(): UseConversationHistoryHookResult {
    const state = useConversationHistoryState();

    const actions = useConversationHistoryActions();

    return {
        ...state,
        ...actions,
    };
}
